import { usePostHttp } from "../../http.hook";
import type { IOtp } from "../../../../types/models/otp.models.types";

interface IBody {
  email: string;
}

interface IOtpResponse extends IOtp {}

export function useAdminSendOtpCommonHttp() {
  return usePostHttp<IBody, IOtpResponse>({
    path: "/common/users/authentication/email/otp",
  });
}
